import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import MasterData from '../data/MasterData'
import { useIntl } from 'react-intl'

const LineSelector = ({ lineName, type, themeName }) => {
  const intl = useIntl()
  const locale = intl.locale

  return (
    <ul className="c-LineTab">
      <li className={`c-LineTab-item c-LineTab-item--${themeName} ${lineName === 'for_jre' ? 'is_current' : ''} is_${locale}`}>
        <Link to={`/lines/for_jre/${type}#28`}>{MasterData.line(4)[`name_${locale}`]}</Link>
      </li>
      <li className={`c-LineTab-item c-LineTab-item--${themeName} ${lineName === 'for_tokyu' ? 'is_current' : ''} is_${locale}`}>
        <Link to={`/lines/for_tokyu/${type}`}>{MasterData.line(3)[`name_${locale}`]}</Link>
      </li>
      <li className={`c-LineTab-item c-LineTab-item--${themeName} ${lineName === 'main' ? 'is_current' : ''} is_${locale}`}>
        <Link to={`/lines/main/${type}`}>{MasterData.line(1)[`name_${locale}`]}</Link>
      </li>
      <li className={`c-LineTab-item c-LineTab-item--${themeName} ${lineName === 'izumino' ? 'is_current' : ''} is_${locale}`}>
        <Link to={`/lines/izumino/${type}`}>{MasterData.line(2)[`name_${locale}`]}</Link>
      </li>
    </ul>
  )
}

LineSelector.propTypes = {
  lineName: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  themeName: PropTypes.string.isRequired,
}

export default LineSelector
